import { useEffect, useState, useRef } from "react";

const SeasonDropdownMenu = ({ onChange }) => {
  const currentYear = new Date().getFullYear();
  const currentSeason = currentYear - 2024 + 1;
  const [season, setSeason] = useState(currentSeason);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Populate the dropdown list with the appropriate number of seasons
  useEffect(() => {
    // Tracking mouse to determine when to stop showing dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSeasonSelect = (newSeason) => {
    onChange(newSeason);
    setSeason(newSeason);
    setIsDropdownOpen(false);
  };

  const listOfSeasons = [];
  for (let i = 0; i <= currentSeason; i++) {
    if (i === 0) listOfSeasons.push("All");
    else listOfSeasons.push(i);
  }

  return (
    <div ref={dropdownRef} className="relative inline-block text-left mb-2">
      <span className="mr-2 font-semibold">Season:</span>
      <button
        onClick={toggleDropdown}
        className="w-8 h-8 bg-primaryColor border border-gray-300 rounded-md hover:bg-dimWhite"
      >
        {season}
      </button>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <ul className="absolute left-[4.35rem] z-10 mt-2 bg-primaryColor border border-gray-300 rounded-lg shadow-lg">
          {listOfSeasons.map((season, index) => (
            <li
              key={season}
              className={`w-8 h-8 text-center hover:bg-dimWhite hover:rounded-md cursor-pointer ${
                index !== listOfSeasons.length - 1 ? "border-b" : ""
              }`}
              onClick={() => handleSeasonSelect(season)}
            >
              {season}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SeasonDropdownMenu;
